<template>
  <v-layout column>
    <v-flex xs12>
      <v-card class="elevation-3 py-2">
        <v-card-title v-if="order.number"
          ><span
            >Заказ №{{ order.number }} от {{ order.created | datetime }} по
            адресу
            <span class="primary--text">
              {{ this.order.items[0].pointAddress }}
            </span>
            на сумму
            <span class="primary--text">
              {{
                this.order.items.reduce(function (sum, current) {
                  return sum + current.price * current.quantity;
                }, 0) | twoDecimalPoint
              }}
            </span>
          </span>
        </v-card-title>

        <v-card-text>
          <v-data-table
            hide-default-footer
            item-key="orderItemId"
            :headers="headers"
            :items="order.items"
            :items-per-page="-1"
          >
            <template v-slot:[`item.expiration`]="{ item }">{{
              item.expiration | expiration
            }}</template>

            <template v-slot:[`item.price`]="{ item }">
              <v-layout justify-end>{{ item.price }}</v-layout>
            </template>

            <template v-slot:[`item.quantity`]="{ item }">
              <v-layout justify-end>{{ item.quantity }}</v-layout>
            </template>

            <template v-slot:no-data>
              <v-alert :value="true" type="warning">Записи не найдены</v-alert>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  props: {
    order: Object,
  },
  computed: {},
  methods: {},
  data: () => ({
    search: "",
    headers: [
      { text: "Наименование", value: "productName" },
      { text: "Производитель", value: "manufacturer" },
      { text: "Страна", value: "productCountry" },
      { text: "Срок годности", value: "expiration", align: "center" },
      { text: "Цена", value: "price", align: "right", width: "9%" },
      { text: "Количество", value: "quantity", align: "right" },
      { text: "Статус", value: "state", align: "right", width: "9%" },
    ],
    icons: {
      mapMarker: Icon.mapMarker,
    },
  }),
  mounted: function () {},
};
</script>
